'use client';

import { useEffect, type ReactNode } from 'react';
import { useRouter } from 'next/navigation';
import { useLocalePath } from '@/hooks/use-locale';
import { useSession } from '@/hooks/use-session';
import { HomeSearchMergeProvider } from '@/new_components/home-live/home-search-merge';
import Demo7Layout from './components/layouts/demo7/layout';

export default function Home({ children }: { children: ReactNode }) {
  const { status } = useSession();
  const router = useRouter();
  const localePath = useLocalePath();
  useEffect(() => {
    if (status === 'authenticated') router.replace(localePath('/overview'));
  }, [status, router, localePath]);
  // The provider lets the hero reveal the header's search as it scrolls up
  // into it; the header and the page body are siblings under Demo7Layout.
  return (
    <HomeSearchMergeProvider>
      <Demo7Layout hideGridLines>{children}</Demo7Layout>
    </HomeSearchMergeProvider>
  );
}
